/** Statsig experiment key for the intake summary delayed A/B. */
export const PROVIDER_INTAKE_SUMMARY_EXPERIMENT = 'provider_intake_summary_experiment';

/** Statsig layer that owns the intake summary experiment param. */
export const PROVIDER_INTAKE_REVIEW_LAYER = 'provider_intake_review';

/** Layer param that indicates treatment allocation for intake summary. */
export const INTAKE_SUMMARY_LAYER_PARAM = 'shouldShowIntakeSummary';

/** Dynamic config driving cutover/stages for the delayed experiment. */
export const PROVIDER_INTAKE_SUMMARY_DELAYED_EXPERIMENT_CONFIG = 'provider_intake_summary_delayed_experiment';
